import Rules from '@lsfe/rules';
import {
    divide, multiply,
    plus, toFixed,
} from '@lsfe/tools';

export const orderTypeEnum = {
    A: 0,
    B: 1,
    C: 2,
};

// 精准预约类型枚举
export const accurateReserveEnum = {
    ACCURATE: 1, // 精准预约
    NOT_ACCURATE: 0, // 非精准预约
};

// 单据类型枚举
export const billTypesEnum = {
    MATERIAL: 4, // 原料
};

export const purTableColumns = [
    {
        type: 'selection',
        label: '全选',
        reserveSelection: true,
        selectable(row) {
            return +row.currentTotalBoxCount;
        },
    },
    { label: '约定到货日期', prop: 'preArrivalTime', width: 120 },
    { label: '收货地点', prop: 'targetPoiName' },
    { label: '采购单号', prop: 'cgNo', width: 125 },
    { label: '供应商', prop: 'supplierIdName', width: 125 },
    { label: '可预约SKU数', prop: 'canBeReservedSkuCount', width: 100 },
    { label: '本次预约SKU数', prop: 'currentTotalSkuCount', width: 110 },
    { label: '可预约总箱数', prop: 'canBeReservedBoxCount', width: 100 },
    { label: '本次预约箱数', prop: 'currentTotalBoxCount', width: 110 },
    { label: '操作', prop: 'operate', width: 100 },
];

export const encryp = (string) => {
    if (typeof string !== 'string' || string.length === 0) {
        return '--';
    }
    if (string.length === 1) {
        return '*';
    }
    return `${string[0]}*...*${string[string.length - 1]}`;
};

// sku明细修改
export const skuDetailColumns = [
    {
        label: '',
        prop: 'isChecked',
        width: 70,
    },
    { label: 'skuId', prop: 'skuId' },
    { label: '条形码', prop: 'skuCode' },
    { label: '商品名称', prop: 'skuName' },
    { label: '采购数量', prop: 'hopeQuantity' },
    { label: '箱规', prop: 'boxQuantity' },
    { label: '采购箱数', prop: 'hopeBox' },
    { label: '可预约数量', prop: 'canReservedQuantity' },
    {
        label: '本次预约数量',
        prop: 'reserveQuantity',
    },
    {
        label: '本次预约箱数',
        prop: 'reserveBox',
    },
    {
        label: '是否云仓',
        prop: 'ycFlagDesc',
    },
    {
        label: '可预约时间',
        prop: 'reserveTimeRange',
        width: 150,
    },
];
export const printColumns = [
    {
        label: '采购单',
        prop: 'cgNo',
        width: 45,
    },
    {
        label: '品类',
        prop: 'categoryDesc',
        width: 45,
    },
    {
        label: '链路标识',
        prop: 'chainTagDesc',
        width: 45,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        formatter: (row) => (([orderTypeEnum.B, orderTypeEnum.C].includes(row.orderType)) ? encryp(row.skuName) : row.skuName),
    },
    {
        label: '条形码',
        prop: 'skuCode',
        formatter: (row) => (([orderTypeEnum.B, orderTypeEnum.C].includes(row.orderType)) ? encryp(row.skuCode) : row.skuCode),
        width: 45,
    },
    {
        label: 'SKUID',
        prop: 'skuId',
        width: 45,
    },
    {
        label: '存储条件',
        prop: 'storageCondition',
        width: 45,
    },
    {
        label: '保质期',
        prop: 'guaranteePeriodDesc',
        width: 45,
    },
    {
        label: '箱规',
        prop: 'boxQuantity',
        width: 45,
    },
    {
        label: '托规',
        prop: 'palletCapacity',
        formatter: (row) => (row.palletConfig ? (row.palletConfig.palletCapacity ?? '--') : '--'),
        width: 45,
    },
    {
        label: '层规',
        prop: 'layerCapacity',
        formatter: (row) => (row.palletConfig ? (row.palletConfig.layerCapacity ?? '--') : '--'),
        width: 45,
    },
    {
        label: '层数',
        prop: 'layerCount',
        formatter: (row) => (row.palletConfig ? (row.palletConfig.layerCount ?? '--') : '--'),
        width: 45,
    },
    {
        label: '高优品',
        prop: 'highPriority',
        template: {
            tpl: 'enum',
            list: [
                {
                    value: 1,
                    label: '是',
                },
                {
                    value: 0,
                    label: '否',
                },
                {
                    value: '',
                    label: '--',
                },
            ],
        },
        width: 45,
    },
    {
        label: '物流标签',
        prop: 'logisticLabelDesc',
        width: 45,
    },
    {
        label: '预约箱数',
        prop: 'totalBoxCount',
        width: 45,
    },
    {
        label: '预约数量',
        prop: 'totalSkuCount',
        width: 45,
    },
    {
        label: '云仓',
        prop: 'ycFlagDesc',
        formatter: (row) => (row?.ycFlagDesc || '--'),
        width: 45,
    },
    {
        label: '流向',
        prop: 'orderFlowDirectionRdcName',
        width: 45,
    },
];

export const computedBox = (row) => {
    const { boxQuantity, reserveQuantity } = row;
    let reserveBox = 0;
    if (reserveQuantity) {
        reserveBox = +toFixed(divide(+reserveQuantity, +boxQuantity), 3);
    }
    return reserveBox;
};

export const computedQuantity = (row) => {
    const { boxQuantity, reserveBox } = row;
    let reserveQuantity = 0;
    if (reserveBox) {
        reserveQuantity = +toFixed(multiply(+reserveBox, +boxQuantity));
    }
    return reserveQuantity;
};

export const computedSum = (data) => data.reduce(
    (sum, row) => {
        if (row.isChecked) {
            sum.reserveQuantity = +toFixed(
                plus(sum.reserveQuantity, +row.reserveQuantity),
                2,
            );
            sum.reserveBox = +toFixed(plus(sum.reserveBox, +row.reserveBox), 3);
        }
        return sum;
    },
    { reserveQuantity: 0, reserveBox: 0 },
);

// 正整数 || 0
export const validateNonNegativeInteger = (value) => {
    const val = Number(value);
    if (Number.isNaN(val)) {
        return false;
    }
    if ((Number.isInteger(val) && val > 0) || val === 0) {
        return true;
    }
    return false;
};

// 非负数（最多三位小数）
const validateNonNegativeNumber = (value) => {
    const num = Number(value);
    if (Number.isNaN(num) || num < 0) {
        return false;
    }
    const decimalPart = value.toString().split('.')[1];
    return !decimalPart || decimalPart.length <= 3;
};


const detachFlagRule = (row) => +row.packageType === 1 && +row.detachFlag !== 0; // detachFlag: 0 不可拆，1: 可拆

export const getReserveQuantityHelper = (row) => {
    const { reserveQuantity, canReservedQuantity } = row;
    let helper = '';
    if (detachFlagRule(row) && !validateNonNegativeInteger(reserveQuantity)) {
        helper = '标品请填整数';
    } else if (!validateNonNegativeNumber(reserveQuantity)) {
        helper = '请输入正确的数字（最多三位小数）';
    } else if (Number(reserveQuantity) > Number(canReservedQuantity)) {
        helper = '不可超过可预约数量';
    }
    return helper;
};
export const getReserveBoxHelper = (row) => {
    const { reserveBox } = row;
    let helper = '';
    if (row.onlyChooseBoxCount && !validateNonNegativeInteger(reserveBox)) {
        helper = '越库散装品 请填整数';
    }
    if (!validateNonNegativeNumber(reserveBox)) {
        helper = '请输入正确的数字（最多三位小数）';
    }
    return helper;
};

export const POI_TYPE = {
    RDC: 2,
    TDC: 5,
};

// 装卸服务需求枚举
export const UNLOAD_SERVICE_NEED = {
    NEED: 1, // 需要
    NO_NEED: 0, // 不需要
};

// 产地前置质检需求枚举
export const QUALITY_CHECK_NEED = {
    NEED: 1, // 需要
    NO_NEED: 0, // 不需要
};

export const qualityCheckList = [
    { value: QUALITY_CHECK_NEED.NEED, label: '需要' },
    { value: QUALITY_CHECK_NEED.NO_NEED, label: '不需要' },
];

export const qualityCheckRules = {
    needOriginPreQuality: [
        Rules.isRequired('请选择是否需产地前置质检'),
    ],
    planQualityDate: [
        Rules.isRequired('请选择期望质检时间'),
    ],
    remark: [
        Rules.isRequired('请输入产地质检备注'),
    ],
};
export const qualityCheckFields = [
    {
        prop: 'needOriginPreQuality',
        label: '是否需产地前置质检',
        slot: 'needOriginPreQuality',
    },
    {
        prop: 'planQualityDate',
        label: '期望质检时间',
        slot: 'planQualityDate',
        visible: (data) => data.needOriginPreQuality === QUALITY_CHECK_NEED.NEED,
    },
    {
        prop: 'remark',
        label: '产地质检备注',
        template: {
            component: 'mc-input',
            attrs: {
                type: 'textarea',
                maxlength: 100,
                rows: 3,
                placeholder: '共x车，第x车，车牌号：xxxx',
            },
        },
        visible: (data) => data.needOriginPreQuality === QUALITY_CHECK_NEED.NEED,
    },
];

// 装卸服务合作类型枚举
export const UNLOAD_SERVICE_COOPERATION_TYPE_ENUM = {
    SELF: 1, // 自营
    // 其他类型可补充
};

// 是否需要默认装卸服务枚举
export const NEED_DEFAULT_UNLOAD_SERVICE_ENUM = {
    YES: 1,
    NO: 0,
};

// 是否上次使用产品枚举
export const IS_LAST_USED_PRODUCT_ENUM = {
    YES: 1,
    NO: 0,
};

// 业态类型映射
export const YT_TYPE_MAP = {
    XX_YT: 10, // 小象
    N_YT: 20, // N
    H_YT: 30, // H
};

// 不需要装卸服务的原因选项
export const NO_NEED_UNLOAD_SERVICE_REASON_OPTIONS = [
    { value: '小象自营卸货工人较少，司机不想排队压车', label: '小象自营卸货工人较少，司机不想排队压车' },
    { value: '小象自营卸货较慢，司机不想等待', label: '小象自营卸货较慢，司机不想等待' },
    { value: '小象自营装卸服务不规范，不负责质检及交货', label: '小象自营装卸服务不规范，不负责质检及交货' },
    { value: '装卸费已支付给承运商，如满足司机个人现场付装卸费可以使用小象自营装卸', label: '装卸费已支付给承运商，如满足司机个人现场付装卸费可以使用小象自营装卸' },
    { value: '小象自营卸货收费偏高', label: '小象自营卸货收费偏高' },
    { value: '本次送货量较少，司机个人能够完成独立装卸', label: '本次送货量较少，司机个人能够完成独立装卸' },
    { value: '本次送货，已安排自有员工随车到仓安排送货', label: '本次送货，已安排自有员工随车到仓安排送货' },
];

// 装卸服务项目选项
export const SERVICE_PROJECT_OPTIONS = [
    { value: 1, label: '装卸' },
    { value: 2, label: '交仓' },
    { value: 3, label: '装卸交仓' },
    { value: 4, label: '整托装卸' },
    { value: 5, label: '倒托装卸+交仓' },
    { value: 6, label: '不倒托装卸+交仓' },
];
export const needServiceOptions = [
    { value: NEED_DEFAULT_UNLOAD_SERVICE_ENUM.YES, label: '需要' },
    { value: NEED_DEFAULT_UNLOAD_SERVICE_ENUM.NO, label: '不需要' },
];

/**
 * 获取装卸服务项目名称
 * @param {number} unloadServiceProjectType - 装卸服务项目类型
 * @returns {string} 项目名称
 */
export const getServiceProjectName = (unloadServiceProjectType) => {
    const project = SERVICE_PROJECT_OPTIONS.find((item) => item.value === unloadServiceProjectType);
    return project ? project.label : '';
};
